import axios from "axios";
import history from "./../router/history";
import { message } from "antd";
import { Map } from "immutable";
import { CLIENT_ID, CLIENT_SECRET } from "../constants/index.js";

export const BASE_URL = (function() {
    return process.env.BASE_URL;
})();


const WRITE_BLOCK_FLAG_KEY = "LOS_WRITE_BLOCK";

const WRITE_BLOCKED_MESSAGE = "You are not allowed to perform write actions in this session.";

const isValidateTokenRequest = (config) => {
    const url = config.url || config.baseURL || "";
    return String(url).includes("validate-token");
};

function createWriteBlockedError() {
    const error = new Error(WRITE_BLOCKED_MESSAGE);
    error.isWriteBlocked = true;
    return error;
}

const axiosInstance = axios.create({
    baseURL: process.env.BASE_URL
});
axiosInstance.interceptors.request.use(config => {
    const method = (config.method || "").toLowerCase();
    const blockWrites = typeof window !== "undefined" && localStorage.getItem(WRITE_BLOCK_FLAG_KEY) === "true";

    if (blockWrites && (method === "post" || method === "patch" || method === "put") && !isValidateTokenRequest(config)) {
        message.error(WRITE_BLOCKED_MESSAGE, 3);
        // message.error("You are not allowed to perform write actions in this session.", 3);
        // const error = new axios.Cancel("Write operations are blocked for this user.");
        return Promise.reject(createWriteBlockedError());
        // return Promise.reject(error);
    }

    try {
        config.headers.Authorization = `Bearer ${localStorage.getItem(
            "Authorization"
        )}`;
    } catch (error) {
        if (error.response && error.response.status >= 500) {
            message.error("Failed to execute. Please try after sometime", 3);
            return Promise.reject(error);
        }
    }
    return config;
});

axiosInstance.interceptors.response.use(
    _ => _,
    _ => {
        if (_.response && _.response.status >= 500) {
            message.error("Failed to execute. Please try after sometime", 3);
            return Promise.reject(_.response && _.response.data);
        } else if(_.response && _.response.status === 404) {
            return Promise.reject(_.response);
        }
        else if(
            _.response &&
            [401, 429].includes(_.response.status)
        ) {
            return Promise.reject(_.response && _.response.data);
        }
        else if (
            _.response && 
            _.response.status >= 400 && 
            _.response.status !== 403 &&
            !(_.response.data.length &&
            typeof _.response.data === "object" &&
            _.response.data.find(_ => _ === "invalid_grant")
            )
        ) {
            if(_.response.data && typeof _.response.data !== "string" && !_.response.data.length && typeof _.response.data === "object") {
                _.response.data && new Map(_.response.data).map((e, k) => {
                    if(typeof e !== "object") {
                        return message.error(`${k} - ${e}`, 3);
                    }
                }).toList().toArray();
            }

            return Promise.reject(_.response && _.response.data);
        } else if(
            _.response && 
            _.response.status >= 400 && 
            _.response.status !== 403 &&
            _.response.status !== 401 &&
            _.response.status !== 429 &&
            !(_.response.data.length &&
            typeof _.response.data === "string")
        ) {
            return Promise.reject(_.response && _.response.data);
        }
        else if (_.response && _.response.status === 403) {
            let data = new FormData();
            // data.append(
            //     "access_token",
            //     sessionStorage.getItem("Authorization")
            // );
            data.append(
                "refresh_token",
                localStorage.getItem("RefreshToken")
                
            );
            data.append("grant_type", "refresh_token");
            data.append("client_id", CLIENT_ID);
            data.append("client_secret", CLIENT_SECRET);
            return axios
                .post(`${process.env.BASE_URL}/o/token/v2/`, data)
                .then(res => {
                    sessionStorage.setItem(
                        "Authorization",
                        res.data.access_token
                    );
                    sessionStorage.setItem(
                        "RefreshToken",
                        res.data.refresh_token
                    );
                    _.response.config.headers["Authorization"] = `Bearer ${res.data.access_token}`;
                    return axiosInstance(_.response.config);
                })
                .catch(() => {
                    if (window.location.pathname !== "/auth") {
                        sessionStorage.removeItem("Authorization");
                        sessionStorage.removeItem("RefreshToken");
                        sessionStorage.removeItem("caseListingRedirected");
                        history.replace("/auth");
                    }
                });
        } else {
            return Promise.reject(_);
        }
    }
);

export default axiosInstance;
